import React from 'react';
import { useDMEngine } from '../hooks/useDMEngine';

export default function DMShell({ children }) {
  useDMEngine();
  return (
    <>
      {/* Ambient */}
      <div className="dm-ambient" />
      <div id="dm-flash" />
      {/* Overlays */}
      <div id="dm-toast" />
      {/* App */}
      {children}
    </>
  );
}
